import React, { useEffect, useRef, useState } from 'react'
import ReactQuill from 'react-quill'
import { Quill } from 'quill'

interface CustomReactQuillProps {
  value: string
  onChange: (content: string) => void
}

const RichTextEditor: React.FC<CustomReactQuillProps> = ({ value, onChange }) => {
  const quillRef = useRef<ReactQuill & { getEditor?: () => Quill }>(null)
  const [isFirstRender, setIsFirstRender] = useState(true)

  useEffect(() => {
    if (quillRef.current && !isFirstRender) {
      const quillInstance = quillRef.current.getEditor()
      quillInstance.clipboard.dangerouslyPasteHTML(value)
    }
    if (isFirstRender) setIsFirstRender(false)
  }, [])

  const modules = {
    toolbar: [['bold', 'italic', 'underline'], [{ list: 'bullet' }, { list: 'ordered' }], ['link']],
    clipboard: {
      matchVisual: false,
    },
  }

  const formats = ['bold', 'italic', 'underline', 'list', 'bullet', 'ordered', 'link']

  return (
    <ReactQuill
      className="rich-text-editor"
      id="input-text-editor"
      theme="snow"
      modules={modules}
      formats={formats}
      ref={quillRef}
      value={value}
      onChange={onChange}
    />
  )
}

export default RichTextEditor
